<template>
  <SalesEarningsGraph
    class="graph"
    heading="DASHBOARD.SALES_GRAPH.HEADING"
    subheading="DASHBOARD.SALES_GRAPH.SUBHEADING"
    sales-subheading="DASHBOARD.SALES_GRAPH.SALES_SUBHEADING"
    earnings-subheading="DASHBOARD.SALES_GRAPH.EARNINGS_SUBHEADING"
    :default-time-filter="defaultTimeFilter"
    :data="timelineData"
    :initialized="initialized"
    :error="loadError"
    @on-load-data="update"
    @retry="retry"
  />
</template>

<script>
import statisticsService from 'commons/api/statisticsService/statisticsService';
import { mapState } from 'pinia';
import SalesEarningsGraph from 'src/app/components/charts/sales/SalesEarningsGraph.vue';
import { TIME_FILTERS } from 'src/app/components/charts/sales/timeFilters';
import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import parseISO from 'date-fns/parseISO';
import { isEqual } from 'date-fns';
import { useStatisticsStore } from 'commons/stores/statistics';
import { useOnboardingStore } from 'commons/stores/onboarding';

export default {
  name: 'Sales',
  components: {
    SalesEarningsGraph,
  },
  data() {
    return {
      timelineData: null,
      initialized: false,
      loadError: false,
      lastFilters: null,
      defaultTimeFilter: TIME_FILTERS.MONTH,
    };
  },
  computed: {
    ...mapState(useOnboardingStore, { onboardingFinished: 'finished' }),
    ...mapState(useStatisticsStore, ['lifetimeSales']),
    display() {
      return this.lifetimeSales || this.onboardingFinished;
    },
  },
  methods: {
    async update(filters) {
      this.initialized = false;
      this.loadError = false;
      this.lastFilters = filters;

      try {
        const data = await statisticsService.getSalesOverview({
          pos: filters.pos.value,
          dateFrom: filters.time.from,
          dateTo: filters.time.to,
        });
        this.timelineData = data.timeline ? data : null;

        // ensure that we only got dates back that are actually between the from and to date
        if (this.timelineData?.timeline) {
          this.timelineData.timeline = this.timelineData.timeline.filter(
            (dataPoint) =>
              (!filters.time.from ||
                isAfter(parseISO(dataPoint.saleDate), filters.time.from) ||
                isEqual(parseISO(dataPoint.saleDate), filters.time.from)) &&
              (!filters.time.to ||
                isBefore(parseISO(dataPoint.saleDate), filters.time.to) ||
                isEqual(parseISO(dataPoint.saleDate), filters.time.to)),
          );
        }

        this.initialized = true;
      } catch (error) {
        console.error('dashboard sales statistics failed', error);
        this.loadError = true;
      }
    },
    retry() {
      if (this.lastFilters) {
        this.update(this.lastFilters);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
</style>
